import infoInquiry from '@/api/info-inquiry'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  found_data: {},
  nationalities: [],
  main_programs: [],
  sub_programs: [],
  study_times: [],
  provinces: [],
  districts: [],
  communes: [],
  villages: [],
  fromSchools: [],
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY'),
  is_registered: null,
  branch_id: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_FOUND_DATA (state, data) {
    state.found_data = data
  },
  SET_NATIONALITIES (state, data) {
    state.nationalities = data
  },
  SET_MAIN_PROGRAMS (state, data) {
    state.main_programs = data
  },
  SET_SUB_PROGRAMS (state, data) {
    state.sub_programs = data
  },
  SET_STUDY_TIMES (state, data) {
    state.study_times = data
  },
  SET_PROVINCES (state, data) {
    state.provinces = data
  },
  SET_DISTRICTS (state, data) {
    state.districts = data
  },
  SET_COMMUNES (state, data) {
    state.communes = data
  },
  SET_VILLAGES (state, data) {
    state.villages = data
  },
  SET_DATE_FROM (state, date) {
    state.date_from = date
  },
  SET_DATE_TO (state, date) {
    state.date_to = date
  },
  SET_IS_REGISTERED (state, data) {
    state.is_registered = data
  },
  SET_FROM_SCHOOL (state, data) {
    state.fromSchools = data
  },
  SET_BRANCH_ID (state, data) {
    state.branch_id = data
  }
}

export const actions = {
  fetch (context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to,
        is_registered: context.state.is_registered,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true
      },
      attrubutes
    )
    return infoInquiry.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store (context, data) {
    return infoInquiry.store(data)
  },
  update (context, data) {
    return infoInquiry.update(data)
  },
  destroy (context, id) {
    return infoInquiry.destroy(id)
  },
  async find (context, id) {
    if (_.isEmpty(context.state.found_data)) {
      let response = await infoInquiry.find(id)
      context.commit('SET_FOUND_DATA', response.data)
    }
  },

  async dataBeforeCreate (context) {
    if (!context.state.nationalities.length > 0) {
      let response = await infoInquiry.nationality()
      context.commit('SET_NATIONALITIES', response)
    }
    if (!context.state.main_programs.length > 0) {
      let response = await infoInquiry.mainProgram()
      context.commit('SET_MAIN_PROGRAMS', response)
    }
    if (!context.state.study_times.length > 0) {
      let response = await infoInquiry.studyTime()
      context.commit('SET_STUDY_TIMES', response)
    }
    if (!context.state.provinces.length > 0) {
      let response = await infoInquiry.province()
      context.commit('SET_PROVINCES', response)
    }
    let response = await infoInquiry.fromSchool()
    context.commit('SET_FROM_SCHOOL', response)
  },

  async getSubProgram (context, acp_id) {
    context.commit('SET_SUB_PROGRAMS', [])
    let response = await infoInquiry.subProgram(acp_id)
    context.commit('SET_SUB_PROGRAMS', response)
  },
  async getDistrict (context, province_code) {
    context.commit('SET_DISTRICTS', [])
    context.commit('SET_COMMUNES', [])
    context.commit('SET_VILLAGES', [])
    let response = await infoInquiry.district(province_code)
    context.commit('SET_DISTRICTS', response)
  },
  async getCommune (context, district_code) {
    context.commit('SET_COMMUNES', [])
    context.commit('SET_VILLAGES', [])
    let response = await infoInquiry.commune(district_code)
    context.commit('SET_COMMUNES', response)
  },
  async getVillage (context, commune_code) {
    context.commit('SET_VILLAGES', [])
    let response = await infoInquiry.village(commune_code)
    context.commit('SET_VILLAGES', response)
  },
  async getFromSchool (context, commune_code) {
    context.commit('SET_FROM_SCHOOL', [])
    let response = await infoInquiry.fromSchool(commune_code)
    context.commit('SET_FROM_SCHOOL', response)
  }
}
